import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

type InlineLoadingStyle = Record<string, string | number | null | undefined>;
type InlineLoadingVariant = 'spinner' | 'dots' | 'ring';

@Component({
    selector: 'core-ui-inline-loading',
    templateUrl: './inline-loading.component.html',
    styleUrls: ['./inline-loading.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InlineLoadingComponent {
    private readonly dotsGapPx = 2;

    readonly spinnerBlades = Array.from({ length: 8 });
    readonly dots = Array.from({ length: 3 });

    @Input() text = '';
    @Input() sizePx = 16;
    @Input() loadingStyle: InlineLoadingStyle | null = null;
    @Input() variant: InlineLoadingVariant = 'spinner';
    @Input() color: string | null = null;
    @Input() progress: number | null = null;

    get ringProgress(): number | null {
        return this.variant === 'ring' && this.progress !== null && Number.isFinite(this.progress)
            ? Math.min(100, Math.max(0, this.progress))
            : null;
    }

    @HostBinding('style.color')
    get hostColor(): string | null {
        return this.color;
    }

    get bladeWidthPx(): number {
        return Math.max(2, Math.round(this.sizePx * .14));
    }

    get bladeHeightPx(): number {
        return Math.max(5, Math.round(this.sizePx * .28));
    }

    get bladeOriginYPx(): number {
        return this.sizePx / 2;
    }

    get dotSizePx(): number {
        return Math.max(4, Math.round(this.sizePx * .28));
    }
}
